import {
  mapState
} from "vuex";

import UserInfo from '@/components/UserInfo'
import ApprovalStatus from '@/components/ApprovalStatus'
import projectInfo from '@/page/user/projectInfo'
import approvalType from '@/Mixins/approvalType'
export default {
  components: {
    projectInfo,
    UserInfo,
    ApprovalStatus,
  },
  mixins: [approvalType],
  computed: {
    ...mapState({
      organization: state => state.main.organization,
      userData: state => state.main.userData,
      approvalSuccess: state => state.main.approvalSuccess,
      tipNum: state => state.main.tipNum,
      isMobile: state => state.main.isMobile,
    })
  },
  data() {
    return {
      // 移动端
      isConcat: false,

      // 后端分页
      form: {
        approvalType: 0,
        page: 0,
        pageSize: 20,
        searchName: '',
        status: '全部',
        type: 0
      },

      filter: {
        type: '-1',
        status: "全部",
      },
      statusArr: ['全部', '进行中', '审批通过', '已拒绝', '已取消'],
      // 审批数据type
      // tabType: 0,
      // 列表
      loading: true,
      pageTotal: 0,
      listData: [],
      filterData: [],
      paginationData: [],

      filterKey: "",
      approvalType: "",

      // approvalTypeName
      approvalTypeName: ['所有', '印章', '工程', '合同', '微型B', '原水微型B', '材料领用', '款项', '采购', '材料退库', '易耗品', '通用审批', '车辆', '请/休假', '人员', '资产', '废弃', '供应商准入', '会议', '考勤未签到'],
    }
  },
  mounted() {
    this.getLists()
    this.popHeight = document.documentElement.clientHeight - 150
  },
  methods: {
    getApprovalTitle(row) {
      if (row.type == 4) {
        if (row.subType == 3 || row.subType == 4) {
          return this.approvalTitle["key_4_3"]
        } else {
          return this.approvalTitle["key_4"]
        }
      } else {
        return this.approvalTitle['key_' + row.type]
      }
    },
    getApprovalTypeName(row) {
      let _type = row.approvalType / 1
      let _typeName = '<span class="approval-type at' + _type + '">' + this.approvalTypeName[_type] + '</span>';

      if (row.wxType == "A") {
        _typeName = '<span class="approval-type at4">' + '微型A' + '</span>'
      }
      // console.log(_type)
      return _typeName
    },
    getDateByTime(time) {
      return time
      // return time;window.util.getFormatDate(time, true)
    },
    arpproval(row) {
      this.$store.commit('set_approval_row', row)
      this.$store.commit('set_approvalId', row.flow.curApprovalId)
      this.$store.commit('set_approvalType', 1)
    },
    // getProjectStatus(type) {
    //   for (var i = 0; i < this.typeArr.length; i++) {
    //     let _item = this.typeArr[i]
    //     if (type == _item.type) {
    //       return _item.title
    //     }
    //   }
    // },
    projectDetail(row) {
      this.$store.commit('set_projectTable', {
        status: false,
        applyId: "",
        tableType: "",
      })

      setTimeout(() => {
        let _projectTable = {
          status: true,
          applyId: row.id,
          tableType: row.type,
        }
        this.$store.commit('set_projectTable', _projectTable)
      }, 10);

    },
    getUserList(users) {
      let _item = ""
      for (var i = 0; i < users.length; i++) {
        _item += '<span class="user-item">' + users[i].name + '</span>'
      }
      return _item
    },
    // 当前页
    handleCurrentChange(val) {
      this.form.page = val - 1
      this.getLists()
    },
    // 分页筛选数据
    getPaginationData() {

      // if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
      //   this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
      // }
      // if (this.currentPage == 0) {
      //   this.currentPage = 1
      // }

      // // 分页筛选
      // if (this.isMobile) {
      //   this.paginationData = this.filterData.slice(0, this.pageSize * this.currentPage)
      // } else {
      //   this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      // }
      if (this.isMobile && this.isConcat) {
        this.paginationData = this.paginationData.concat(this.filterData)
      } else {
        this.paginationData = this.filterData
      }
    },
    // 移动版分页增加加载页数
    addCurrentPage() {
      console.log('loading')
      this.form.page++
      this.isConcat = true
      // this.getPaginationData()
      this.getLists()

    },
    // 获取列表
    getLists() {
      // 0803 更新系统分页
      this.loading = true
      ajax.post('/user/project/approval', this.form, (res) => {
        this.loading = false
        this.filterData = this.listData = res.vo.list
        this.pageTotal = res.vo.size
        this.getPaginationData()
      })
    },
  },
  watch: {
    approvalSuccess() {
      if (this.approvalSuccess) {
        this.getLists()
        this.$store.commit('set_approvalSuccess', false)
      }
    },
    'form.approvalType'() {
      this.form.page = 0
      this.isConcat = false
      this.getLists()
    },
    'form.status'() {
      this.form.page = 0
      this.isConcat = false
      this.getLists()
    },
    'form.type'() {
      this.form.page = 0
      this.isConcat = false
      this.getLists()
    },
    'form.searchName'() {
      this.form.page = 0
      this.isConcat = false
      this.getLists()
    },

    // form: {
    //   handler(newName, oldName) {
    //     this.getLists()
    //   },
    //   deep: true
    // }
  }
}



// WEBPACK FOOTER //
// ./src/Mixins/approvalList.js